module.exports = __webpack_public_path__ + "static/media/cynthia-del-rio.9813593c.jpg";